import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { PreWraper } from '@components/shared/wraper/PreWraper'
import { cloudfrontPath } from '@utils/image'
import { useState } from 'react'

type Props = {
  title: string
  children: JSX.Element
}

export const ProgramDescriptionAccordion = ({
  title,
  children,
}: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(true)
  return (
    <div className="flex flex-col">
      <div
        className="flex z-20 flex-row justify-between items-center px-[6.1vw] lg:pr-[1.4vw] lg:pl-[2.9vw] bg-gradient-to-r from-primaryTo to-primaryFrom rounded-[8px] shadow-button lg:hover:opacity-80 lg:hover:cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="py-[4.3vw] lg:py-[1.6vw]">
          <div className="text-[4.8vw] lg:text-[1.9vw] font-bold text-white">
            <h2>
              <PreWraper text={title} />
            </h2>
          </div>
        </div>

        <div className={`lg:w-[2.2vw] w-[7.5vw] ${isOpen ? '' : 'rotate-180'}`}>
          <ImageWraper
            src={`${cloudfrontPath}/programs/icons/top/ellipse_arrow.svg`}
            width={20}
            height={20}
          />
        </div>
      </div>
      <div
        className={`transition-all ${
          isOpen ? 'opacity-1 h-full' : 'opacity-0 h-0'
        }`}
      >
        {children}
      </div>
    </div>
  )
}
